const STATUS_STYLES = {
  Draft: "text-gray-300 bg-gray-400/10 border-gray-400/30",
  Sent: "text-blue-300 bg-blue-400/10 border-blue-400/30",
  Viewed: "text-purple-300 bg-purple-400/10 border-purple-400/30",
  Signed: "text-[#C9963F] bg-[#C9963F]/10 border-[#C9963F]/40",
  "Change Requested": "text-amber-300 bg-amber-400/10 border-amber-400/30",
  Cancelled: "text-red-300 bg-red-400/10 border-red-400/30",
};

export default function StatusBadge({ status, className = "" }) {
  const cls = STATUS_STYLES[status] || STATUS_STYLES.Draft;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-1 text-[10px] uppercase tracking-[0.18em] border ${cls} ${className}`}
    >
      {status}
    </span>
  );
}
